import React from 'react'
import ReactToPrint from "react-to-print";
import { Modal } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';
import { BsXCircle } from 'react-icons/bs'

class PDFViewerModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            action: props.actionTitle,
            show: props.show,
            onChange: props.onChange,
            child: props.children
        }
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={() => {
                    this.state.onChange(false)
                }}>
                <div className="card"
                >
                    <ModalHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
                        <h4><strong> {this.props.title}</strong></h4>
                        <button className="btn btn-dnager rounded-circle text-white" onClick={this.props.onChange}>
                            <BsXCircle size="2em" />
                        </button>
                    </ModalHeader>
                    <ReactToPrint
                        trigger={() => <div className="w-100 m-0 p-1 d-flex justify-content-between align-items-center">
                            <button className="btn btn-primary col-3">
                                {this.state.action}
                            </button>
                        </div>}
                        content={() => this.componentRef}
                        documentTitle="رسید سفر"
                    />


                    <div ref={(el) => (this.componentRef = el)}
                        className="myprint"
                    >
                        {this.props.children}
                    </div>
                </div>
            </Modal>
        );
    }
}

export default PDFViewerModal;